module.exports = __webpack_public_path__ + "img/create_your_library.4f336afa.png";